import React from "react";

export const pomarrosaPublishedAt = (
  <span className="white">
    <i>Rin Rin</i>, No. 8. <i>Revista infantil del Ministerio de Educación</i> (1937), <i>Otra vez en Lilac</i> (1942),{" "}
    <i>Cambam Bali</i> (1973) y <i>Retorno a Lilac</i> (1987)
  </span>
);
